import Vue from 'vue'
import loading from 'vuejs-loading-screen'

Vue.use(loading, {
    bg: 'rgb(0 0 0 / 0.5)',
    size: 5,
    icon_color: 'white',
})